import React from "react";
import InfoTooltip from './compat/InfoTooltip';

import './productConfigSummary.css';

export default class ProductConfigSummary extends React.Component{

  constructor(props){
    super(props);
    this.state={
      mobile: false,
      isAgentVisbile: true
    }
  }

  componentDidMount() {
    if(/Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent) ){
      this.setState({
        mobile: true,
       });
    }
    if(this.props.coupon && Object.keys(this.props.coupon).length > 0 ){
      var coupon = this.props.coupon
      var isAgentVisbile = true

      if(coupon.discountServiceConfig !== null){
        var discountServiceConfig = coupon.discountServiceConfig
        var agentVisibility = discountServiceConfig.agentVisibility

        if(agentVisibility === "N"){
          isAgentVisbile = false
        }
      }

      this.setState({
        isAgentVisbile: isAgentVisbile
       });
    }
  }

  getDiscountedValue(){
    var discount = 0;
    if(this.props.coupon){
      if(this.props.coupon.applicableTo === 'cart'){
        if(this.props.coupon.discountType === 'percentage'){
          discount = this.props.productQuote.totalPerMonth * this.props.coupon.sizePercentage / 100
        }else if(this.props.coupon.discountType === 'fixed'){
          if(this.props.cart != null && Object.keys(this.props.cart).length > 0 && this.props.cart.cartItems.length > 0){
            discount = this.props.coupon.sizeFixed / this.props.cart.cartItems.length;
          } else {
            discount = this.props.coupon.sizeFixed
          }
        }
      } else if(this.props.coupon.applicableTo === 'product'){
        if(this.props.productQuote.discount > 0) {
          discount = this.props.productQuote.discount
        }
      }
    }

    return discount;

  }

  getDiscountedTotalPrice(){
    var price = 0;
    if(this.props.coupon && this.props.coupon.applicableTo === 'cart'){
      var discount = this.getDiscountedValue()
      price = this.props.productQuote.totalPerMonth -  discount
    } else{
      price = this.props.productQuote.totalPerMonth
    }
    return price;

  }

  pricingFormat(value){
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  setSelectedGeographyInvestorPremium(){
    let config = this.props.productPackageDefaultConfig
    let states = config.configuration.geography.states
    let selectedState = ""
    if (config && states!=null) {
      states.map(function(state, index){
        return selectedState = state
      })
    }
    return selectedState
  }

  render(props){
    var contractMonths = 12
    let classNames = require('classnames');
    var orderSummaryClass = classNames({
      "row margin-bottom-60 checkout-content margin-top-160": this.state.mobile === false,
      "row margin-bottom-60 checkout-content": this.state.mobile === true
    });
    var header = classNames({
      "col-xs-8": this.props.productsConfig.quoteServiceType !== 'ReportBundle',
      "col-xs-12": this.props.productsConfig.quoteServiceType === 'ReportBundle'
    });

    if(this.props.quoteLoading === true){
      return(
        <div className="row spinner">
          <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      let configuration = this.props.productsConfig.quoteConfigurationTemplate.configuration
      let industryKey = configuration.industry ? configuration.industry : this.props.selectedIndustry
      let packageKey = configuration.package ? configuration.package
                      : (configuration.packageName ? configuration.packageName
                      : this.props.selectedPackage)
      let geography = ""
      // Adding Selected Geography for Investor Premium
      if (this.props.productsConfig.quoteServiceType === 'ReportBundle' && packageKey === "investors_premium") {
        geography = this.setSelectedGeographyInvestorPremium()
      }

      if(industryKey==="investors"){
        contractMonths = packageKey === 'one_month'? 1 : 6
      }if(industryKey==="real_estate_agencies_and_valuers" && packageKey === "one_month"){
        contractMonths = packageKey === 'one_month'? 1 : 12
      }
      return (
        <div className={orderSummaryClass}>
          {
            this.props.coupon && this.props.coupon.agentName && this.state.isAgentVisbile === true &&
            <div className="row coupon-agent margin-bottom-20">
              Your Consultant is {this.props.coupon.agentName}.
            </div>
          }
          <div className="row">
            <div className={header}>
          {
            this.props.productQuote !== undefined
            && this.props.productQuote !== ''
            && Object.keys(this.props.productQuote).length>0
            && this.props.productsConfig.quoteServiceType !== 'Commercial' && this.props.productsConfig.quoteServiceType !== 'CordellConnect' && this.props.productsConfig.quoteServiceType !== 'CordellEstimator' &&
            <div className="checkout-header">
              {
                industryKey === 'real_estate_agencies_and_valuers'&&
                <span>RP Data</span>
              }
              <br/>
              {
                packageKey === 'trial' &&
                <div>
                  <span className="text-uppercase"> Trial</span> Package
                </div>
              }
              {
                (packageKey === 'basic' || packageKey === 'starter') && industryKey !== 'mortgage_brokers_and_financial_planners' &&
                <div>
                  <span className="text-uppercase"> Starter</span> Package
                </div>
              }
              {
                packageKey === 'one_month'&&
                <div>
                  <span> Lite</span> Package
                </div>
              }
              {
                packageKey === 'essentials'&&
                <div>
                  <span> Essential</span> Package
                </div>
              }
              {
                packageKey === 'lite' && industryKey === 'real_estate_agencies_and_valuers' &&
                <div>
                  <span> Lite</span> Package
                </div>
              }
              {
                packageKey === 'base' && industryKey === 'real_estate_agencies_and_valuers' &&
                <div>
                  <span> Base</span> Package
                </div>
              }
              {
                packageKey === 'premium' && industryKey === 'real_estate_agencies_and_valuers' &&
                <div>
                  <span> Premium</span> Package
                </div>
              }
              {
                packageKey === 'pro' && industryKey === 'real_estate_agencies_and_valuers' &&
                <div>
                  <span> Pro</span> Package
                </div>
              }
              {
                packageKey === 'basic' && industryKey === 'mortgage_brokers_and_financial_planners' &&
                <div>
                  <span> Advisor</span> Package
                </div>
              }
              {
                packageKey === 'pro' && industryKey === 'mortgage_brokers_and_financial_planners' &&
                <div>
                  <span> Broker</span> Package
                </div>
              }
            </div>
          }
          {
            this.props.productsConfig.quoteServiceType === 'Commercial' &&
            <div className="checkout-header">
              <span>
                Commercial
                <br/>
                {
                  packageKey === 'cityscope' &&
                  <div>
                    <span className="text-uppercase"> Cityscope</span> Package
                  </div>
                }
                {
                  packageKey === 'lease_expiry_diary' &&
                  <div>
                    <span className="text-uppercase"> Lease Expiry Diary</span> Package
                  </div>
                }
                {
                  packageKey === 'combo' &&
                  <div>
                    <span className="text-uppercase"> Combo</span> Package
                  </div>
                }
              </span>
            </div>
          }
          {
            this.props.productsConfig.quoteServiceType === 'CordellConnect' &&
            <div className="checkout-header">
              <span>
                Cordell Connect
                <br/>
                {
                  packageKey === 'lite' &&
                  <div>
                    <span className="text-uppercase"> Lite</span> Package
                  </div>
                }
              </span>
            </div>
          }
          {
            this.props.productsConfig.quoteServiceType === 'ReportBundle' &&
            <div className="checkout-header">
              <span>
                Report Bundle
                <br/>
                {
                  packageKey === 'investors_premium' &&
                  <div>
                    <span className="text-uppercase">Investors Premium Bundle</span> Package
                  </div>
                }
              </span>
            </div>
          }
          {
            this.props.productsConfig.quoteServiceType === 'CordellEstimator' &&
            <div className="checkout-header">
              <span>
                Cordell Estimator
                <br/>
                {
                  packageKey === "cordell_estimator_platinum_lite" &&
                  <div>
                    <span className="text-uppercase">Estimator Lite</span> Package
                  </div>
                }
              </span>
            </div>
          }
          </div>
          {
            this.props.productsConfig.quoteServiceType !== 'ReportBundle' &&
            <div className="col-xs-4 text-right">
              <a type="button" className="btn product-config-change-btn off-white-bg" onClick={()=>{this.props.changePackage()}}>Change</a>
            </div>
          }
        </div>

          {
            this.props.productQuote !== undefined && this.props.productQuote !== '' && Object.keys(this.props.productQuote).length>0 &&
            <div>
              <p className="price-tag">
                {
                  parseFloat(this.getDiscountedTotalPrice()) > 0.0 &&
                  <span className="checkout-price">${parseFloat(this.getDiscountedTotalPrice()).toFixed(2)}</span>
                }
                {
                  parseFloat(this.getDiscountedTotalPrice()) <= 0.0 &&
                  <span className="checkout-price">$0.00</span>
                }
                &nbsp;
                {this.props.productQuote.totalPerMonth > 0 &&  packageKey !== 'one_month' && <span className="font-10 text-right captions">Per month</span>}
                {
                  this.props.productQuote.totalPerMonth === 0 &&
                  this.props.productsConfig.quoteServiceType !== 'Commercial' &&
                  ((this.props.productsConfig.quoteServiceType === 'CordellConnect' || this.props.productsConfig.quoteServiceType === 'RPPRealEstate') && packageKey === 'trial') &&
                  <span className="font-10 text-right captions">for 7 days</span>
                }
                {
                  this.props.productQuote.totalPerMonth === 0 &&
                  (this.props.productsConfig.quoteServiceType === 'Commercial' ||
                  (this.props.productsConfig.quoteServiceType === 'CordellConnect'  && packageKey !== 'trial')) &&
                  <span className="font-10 text-right captions">Per month</span>
                }
              </p>
              {
                this.props.productQuote.totalPerMonth === 0 &&
                this.props.productsConfig.quoteServiceType !== 'Commercial' &&
                ((this.props.productsConfig.quoteServiceType === 'CordellConnect' || this.props.productsConfig.quoteServiceType === 'RPPRealEstate') && packageKey === 'trial') &&
                <div className="margin-top-neg20 footnote-text">Min. cost for Trial Period</div>
              }
              {
                this.props.productQuote.totalPerMonth === 0 &&
                (this.props.productsConfig.quoteServiceType === 'Commercial' ||
                (this.props.productsConfig.quoteServiceType === 'CordellConnect' && packageKey !== 'trial')) &&
                <div className="margin-top-neg20 footnote-text">Min. cost is $0.00 over 12 months.</div>
              }
              {
                this.props.productQuote.totalPerMonth > 0 &&
                <div className="margin-top-neg20 footnote-text">
                  Min. cost is ${this.pricingFormat(parseFloat(this.getDiscountedTotalPrice() * contractMonths).toFixed(2))} over {contractMonths}  month(s).
                </div>
              }
              {
                this.getDiscountedValue() > 0 && this.props.productQuote.totalPerMonth > 0 &&
                <div className="row">
                  <div className="col-xs-12">
                    <p className="checkout-discount success-text margin-top-10 footnote-text">You save ${this.getDiscountedValue().toFixed(2)} Per month</p>
                  </div>
                </div>
              }
              {
                this.getDiscountedValue() === 0 &&
                <br/>
              }
              {this.props.productQuote.lineItems && this.props.productQuote.lineItems.length >0 && <p className="wcag-grey-text captions no-margin ">Inclusions</p>}
              {
                this.props.productQuote.lineItems && this.props.productQuote.lineItems.map(function(lineItem, index){
                  if(this.props.productsConfig.quoteServiceType !== 'Commercial'){
                    return(
                      <div className="row" key={index}>
                        <div className="col-sm-12">
                          <p className="no-margin" style={{paddingTop:"5px"}}>{lineItem.description}</p>
                        </div>
                      </div>
                    )
                  } else if(this.props.productsConfig.quoteServiceType === 'Commercial'){
                    return(
                      <div className="row" key={index} style={{paddingTop: "5px"}}>
                        <div className={`col-xs-${packageKey === 'combo' ? '6':'7'}`} style={{paddingTop: "5px"}}>
                          <p className="no-margin">{lineItem.description}</p>
                        </div>
                        <div className={`col-xs-${packageKey === 'combo' ? '6':'5'} text-right`}>
                          <span className="no-margin">${lineItem.total.toFixed(2)}</span>
                          {
                            packageKey === 'combo' && lineItem.description.includes("Lease Expiry") &&
                            <>
                              <br/>
                              <span className="no-margin">(30% Discount Inclusive)</span>
                            </>
                          }
                          {
                            (
                              packageKey === 'combo' && lineItem.description.includes("Lease Expiry") ||
                              lineItem.description.includes("Additional Users")
                            ) ?
                            ''
                            : <i className="fa fa-times-circle close-icon margin-left-5" aria-hidden="true" onClick={()=>{this.props.onRemoveCommercialGeographyPackage(lineItem, index)}}></i>
                          }
                        </div>
                      </div>
                    )
                  } else if(this.props.productsConfig.quoteServiceType === 'CordellConnect' && packageKey === 'residential_essentials'){
                    return(
                      <div className="row" key={index}>
                        {
                          index===0 &&
                          <div className="col-xs-7" style={{paddingTop: "5px"}}>
                            <p className="no-margin" >{lineItem.description}</p>
                            {
                              this.props.productQuote.lineItems && this.props.productQuote.lineItems.length > 1 &&
                              <p className="no-margin" >{this.props.productQuote.lineItems.length-1} {this.props.productQuote.lineItems.length-1 > 1?'councils':'council'}</p>
                            }
                          </div>
                        }
                        {
                          index !== 0 &&
                          <ul>
                            <li style={{paddingTop: "5px"}}>
                              <div className="col-xs-9 no-padding">
                                <p className="no-margin" >{lineItem.description}</p>
                              </div>
                              <div className="col-xs-3 text-right">
                                <i className="fa fa-times-circle close-icon" aria-hidden="true" onClick={()=>{this.props.onDeselectCouncil(lineItem.description)}}></i>
                              </div>
                            </li>
                          </ul>
                        }
                      </div>
                    )
                  }else{
                    return(
                      <div></div>
                    )
                  }
                },this)
              }
              {
                this.props.productPackageDefaultConfig?.configuration?.geography?.national &&
                  <div className="row">
                    <div className="col-sm-12">
                      <p className="no-margin" style={{paddingTop: "5px"}}>National</p>
                    </div>
                  </div>
              }
              {
                this.props.productQuote.features && this.props.productQuote.features.map(function(line, index){
                  var feature_desc
                  // Condition for Investors Premium to output state on features
                  if (line.description.includes("Top Performing Suburbs")) {
                    feature_desc = line.description + " (" + geography + ")"
                  }

                  return(
                    <div className="row" key={index}>
                      <div className="col-xs-10"style={{paddingTop:'5px'}}>
                        <p className="no-margin text-capitalize ">
                          <span className="margin-right-5" >{feature_desc ? feature_desc : line.description}</span>
                          {
                            line.tooltip !== null &&
                            <InfoTooltip text={line.tooltip}>
                              <span>
                                <i className="far fa-question-circle tooltip-icon" style={{top: "0.1em"}} aria-hidden="true"></i>
                              </span>
                            </InfoTooltip>
                          }

                        </p>
                      </div>
                    </div>
                  )
                })
              }
              <br/>
              <div className="row no-margin">
                {this.props.productQuote.addons && this.props.productQuote.addons.length > 0 && <p className="grey-text no-margin captions" style={{paddingBottom:"5px"}}><b> Add Ons</b> </p>}
                {
                  this.props.productQuote.addons && this.props.productQuote.addons.map(function(addon, index){
                    return(
                      <div className="row" key={index} style={{paddingTop: "5px"}}>
                        <div className="col-xs-10" style={{paddingTop: "3px"}}>
                          <p className="no-margin" >{addon.description}</p>
                        </div>
                        <div className="col-xs-2 text-right">
                          <i className="fa fa-times-circle close-icon" aria-hidden="true" onClick={()=>{this.props.onRemoveAddon(addon.description)}}></i>
                        </div>
                      </div>
                    )
                  },this)
                }
              </div>

              {
                ((packageKey === 'investors_premium' && this.props.productQuote.features && this.props.productQuote.features.length > 0) ||
                 (this.props.productQuote.lineItems && this.props.productQuote.lineItems.length > 0)) && !this.props.loading && !this.props.contactsLoader &&
                <div className="row no-margin" style={{paddingTop:"20px"}}>
                  {
                    this.props.checkProductConfigWizard() === false &&
                    <button type="button" className={this.props.loading ? "btn btn-primary add-to-cart no-margin disabled" : "btn btn-primary add-to-cart no-margin" } onClick={()=>{this.props.onAddToCart('buy')}}>
                      Buy it now
                    </button>
                  }
                  <a type="button" className="btn add-to-cart btn-outline-20 off-white-bg" onClick={()=>{this.props.onAddToCart(this.props.checkProductConfigWizard() === true ? 'bundle' : 'add')}}>
                    {this.props.checkProductConfigWizard() === true ? 'Configure Next Product' : 'Add to cart'}
                  </a>
                  {
                    this.props.errorMessage !== null &&
                    <div className="red-text text-center margin-top-10">
                      {this.props.errorMessage}
                    </div>
                  }
                </div>
              }
              {
                (this.props.loading || this.props.contactsLoader) &&
                <div className="row spinner" style={{marginTop: "0px"}}>
                  <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                  <span className="sr-only">Loading...</span>
                </div>
              }
          </div>
          }
          {
            (this.props.productQuote === undefined || this.props.productQuote === '' || Object.keys(this.props.productQuote).length===0) &&
            <div>
              <p className="price-tag captions">
                <span className="checkout-price">$0.00</span>
                &nbsp;
                <span className="font-10 text-right captions">Per month</span>
              </p>
              <div className="grey-text margin-top-neg10 footnote-text">Min. cost is $0.00 over 12 months.</div>
              <hr/>
            </div>
          }

        </div>
      )
    }
  }
}
